module.exports = __webpack_public_path__ + "img/asset3x1.bf675409.png";